var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"videoWrapper",staticClass:"auto-play-video"},[_c('video',{ref:"videoElement",style:({ height: _vm.height }),attrs:{"src":_vm.src,"poster":_vm.poster,"muted":"","playsinline":"","preload":"auto","autoplay":_vm.autoplay,"loop":_vm.loop,"controls":_vm.areControlsVisible},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }